import Navbar from "../components/Navbar";
import EnaiblPageRedesign from "../components/EnaiblPageRedesign";
import CTAFooter from "../components/CTAFooter";

export default function EnaiblPage() {
  return (
    <div className="min-h-screen bg-[#050508] text-white">
      <Navbar />
      <main>
        <EnaiblPageRedesign />
        <CTAFooter />
      </main>
    </div>
  );
}
